import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivePromotionDto } from '../../../models/dto/promotion.dto';
import { PromotionTrackingService } from '../../../core/services/promotion-tracking/promotion-tracking.service';

interface PromotionModalData {
  promotion: ActivePromotionDto;
  userId: string;
}

@Component({
  selector: 'app-modal-promotion-popup',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './modal-promotion-popup.component.html',
  styleUrl: './modal-promotion-popup.component.scss'
})
export class ModalPromotionPopupComponent implements OnInit {
  protected readonly dialogRef = inject(MatDialogRef<ModalPromotionPopupComponent>);
  protected readonly data = inject<PromotionModalData>(MAT_DIALOG_DATA);
  private readonly promotionTrackingService = inject(PromotionTrackingService);

  ngOnInit(): void {
    this.setupBackdropClickHandler();
  }

  private setupBackdropClickHandler(): void {
    this.dialogRef.backdropClick().subscribe(async () => {
      await this.markAsViewedAndClose('backdrop_clicked');
    });
  }

  async onModalClick(): Promise<void> {
    await this.markPromotionAsViewed();

    if (this.data.promotion.button.url) {
      window.open(this.data.promotion.button.url, '_blank', 'noopener,noreferrer');
    }

    this.dialogRef.close({ action: 'modal_clicked' });
  }

  async onButtonClick(): Promise<void> {
    await this.markPromotionAsViewed();

    if (this.data.promotion.button.url) {
      window.open(this.data.promotion.button.url, '_blank', 'noopener,noreferrer');
    }

    this.dialogRef.close({ action: 'button_clicked' });
  }

  async onCloseClick(event?: Event): Promise<void> {
    if (event) {
      event.stopPropagation();
    }
    await this.markAsViewedAndClose('closed');
  }

  protected hasPromotionImage(): boolean {
    return !!(this.getPromotionImageUrl()?.trim());
  }

  protected getPromotionImageUrl(): string | null {
    // Priority: popupImageUrl -> promotionImageUrl -> null
    const popupImage = this.data.promotion?.popupImageUrl?.trim();
    if (popupImage) {
      return popupImage;
    }

    const promotionImage = this.data.promotion?.promotionImageUrl?.trim();
    if (promotionImage) {
      return promotionImage;
    }

    return null;
  }

  protected getButtonText(): string {
    return this.data.promotion.button.text?.trim() || 'Ver promoción';
  }

  private async markPromotionAsViewed(): Promise<void> {
    await this.promotionTrackingService.markPromotionAsViewed(
      this.data.promotion.promotionId,
      this.data.userId
    );
  }

  private async markAsViewedAndClose(action: string): Promise<void> {
    await this.markPromotionAsViewed();
    this.dialogRef.close({ action });
  }
}
